import { Icon, type IChipProps, IconButton, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const InboxChip = ({ label, onDelete }: IChipProps) => {
  return (
    <div className={styles.wrap}>
      <Icon
        className={styles.icon}
        icon='inboxOpen'
        fontSize={16}
        color='var(--content-primary-secondary)'
      />
      <Typography
        ariaLabel='ChipLabel'
        variant='body-md-regular'
        color='var(--content-primary-primary)'
        ellipsis
      >
        {label}
      </Typography>
      {onDelete && (
        <IconButton
          color='transparent'
          size='mini'
          icon='close'
          tag='div'
          variant='icon'
          fontSize={16}
          onClick={onDelete}
          ariaLabel='ChipClose'
          className={styles.closeIcon}
        />
      )}
    </div>
  )
}
